import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import { getInlineLoader } from "../Helpers";
import banner1 from "../assets/banner2.jpg";
import AOS from "aos";
import "aos/dist/aos.css";
import {
  FaCheckCircle,
  FaUsers,
  FaStar,
  FaArrowRight
} from "react-icons/fa";
import { IoMdArrowDropright, IoMdCall, IoMdContact, IoMdHelpCircleOutline, IoMdMegaphone, IoMdNotifications } from "react-icons/io";

export default function HomeBanner3() {
  const appContext = useContext(AppContext);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    setReady(true);
    AOS.init({ duration: 1000, easing: "ease-in-out", once: true });
  }, []);

  if (!ready) {
    return <div className="container mSupportLoading">{getInlineLoader()}</div>;
  }

  return (
    <section
      className="MainBodySection"
      style={{
        backgroundImage: `url(${banner1})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        position: "relative",
        color: "#fff",
        height:"50vh",
      }}
    >
      {/* Overlay */}
      <div
        style={{
          height: "100%",
          width: "100%",
          position: "absolute",
          left:0, top:0,
          background: "rgba(0,0,0,0.75)",
          display: "grid",
          placeItems: "center"
        }}
      >
        <div className="container py-5">
          <div className="row">
            <div className="col-md-12 text-center">
              <h5 className="font-bold mb-2 text-primary" data-aos="fade-down">Premium Agricultural Solutions</h5>
              <h2 className="my-4" data-aos="fade-down">
                Boost Your Crop Yields with Agroseeds & Agrochemicals
              </h2>
              <h6>High-quality seeds and crop protection for healthy, high-yield farming.</h6>
              <div className="d-flex gap-5 mt-5 justify-content-center">
                <button
                  className="text-light py-2 px-0"
                  onClick={() => appContext.navTo({ item: "services" })}
                  style={{
                    transition: ".5s all ease",
                    background: "transparent",
                    border: "none",
                    borderBottom: "2px solid var(--lightColor) !important",
                    outline: "none",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = "translateX(5px)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "translateX(0)";
                  }}
                >
                  View Products &nbsp; <IoMdArrowDropright size={22} />
                </button>

                <button
                  className="text-light py-2 px-0"
                  onClick={() => appContext.navTo({ item: "contact_us" })}
                  style={{
                    transition: ".5s all ease",
                    background: "transparent",
                    border: "none",
                    borderBottom: "2px solid var(--lightColor) !important",
                    outline: "none",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = "translateX(5px)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "translateX(0)";
                  }}
                >
                  Reach Out &nbsp; <IoMdArrowDropright size={22} />
                </button>
              </div>
            </div>
          </div>
          
        </div>
      </div>
    </section>
  );
}
